import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AppService } from 'app/services/app.service';

/**
 * Aree dell'assistente dal server (GET assistant/meta, registro AssistantAreas): unica fonte per il FE di gruppi e
 * switch del pannello del dominio, frase d'apertura, icone dei consigli ed entità supportate. Statiche: una chiamata.
 */
export interface IAssistantAreaMeta{
	key: string;
	entity_type: string;
	label: string;
	name: string;
	description: string;
	where: string;
	intro: string;
	kinds: Record<string, string>;
}

export interface IAssistantMeta{
	entity_types: string[];
	groups: { name: string; icon: string; areas: IAssistantAreaMeta[] }[];
}

/** ultimo meta caricato, per il codice sincrono (config dei campi del dominio) */
let snapshot: IAssistantMeta | null = null;

export function assistantMetaSnapshot(): IAssistantMeta | null{
	return snapshot;
}

@Injectable({
	providedIn: 'root'
})
export class AssistantMetaService{

	readonly meta = new BehaviorSubject<IAssistantMeta | null>(null);
	private loading = false;

	constructor(private http: HttpClient, private appService: AppService){}

	/** idempotente: la prima chiamata scarica, le altre aspettano la stessa risposta */
	load(): void{
		if(this.meta.value || this.loading) return;
		this.loading = true;
		this.http.get<IAssistantMeta>(this.appService.getBaseServerAddress() + '/assistant/meta').subscribe({
			next: meta => {
				snapshot = meta;
				this.meta.next(meta);
			},
			error: () => this.loading = false
		});
	}

	area(key: string | null | undefined): IAssistantAreaMeta | null{
		if(!key || !this.meta.value) return null;
		for(const group of this.meta.value.groups){
			const area = group.areas.find(item => item.key === key);
			if(area) return area;
		}
		return null;
	}

	/** icona del tipo di consiglio (kinds delle aree); sconosciuto → freccia generica */
	icon(kind: string): string{
		for(const group of this.meta.value?.groups || []){
			for(const area of group.areas){
				if(area.kinds[kind]) return area.kinds[kind];
			}
		}
		return 'north_east';
	}
}
